module.exports = __webpack_public_path__ + "static/media/img-4.ce306f88.png";